import { render } from "./ProjectDetail.vue?vue&type=template&id=d01c49f6&scoped=true&ts=true"
import script from "./ProjectDetail.vue?vue&type=script&lang=ts"
export * from "./ProjectDetail.vue?vue&type=script&lang=ts"

import "./ProjectDetail.vue?vue&type=style&index=0&id=d01c49f6&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d01c49f6"]])

export default __exports__